import React from "react";
import { TableRow } from "./TableRow";
import { NoRows } from "../../../layout/Table/NoRows";

function TableBody(props) {
  const renderRows = () => {
    const { organizations } = props;

    if (!Array.isArray(organizations) || organizations.length === 0) {
      return <NoRows colSpan="14" />;
    }

    return organizations.map(renderRow);
  };

  const renderRow = (organization, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        key={organization.id || index}
        organization={organization}
        actionCallback={actionCallback}
        index={index}
      />
    );
  };

  return <tbody>{renderRows()}</tbody>;
}

export { TableBody };
